import React, { useEffect, useId, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import Flag from './Flag'
import { useI18n } from '../i18n/LanguageContext'

function LanguageSwitcher() {
  const { t, lang, languages, switchHref } = useI18n()
  const [open, setOpen] = useState(false)
  const rootRef = useRef(null)
  const buttonId = useId()
  const menuId = useId()
  const current = languages.find((entry) => entry.code === lang)

  useEffect(() => {
    if (!open) return undefined
    const onPointerDown = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) setOpen(false)
    }
    const onKeyDown = (event) => {
      if (event.key === 'Escape') setOpen(false)
    }
    document.addEventListener('pointerdown', onPointerDown)
    document.addEventListener('keydown', onKeyDown)
    return () => {
      document.removeEventListener('pointerdown', onPointerDown)
      document.removeEventListener('keydown', onKeyDown)
    }
  }, [open])

  // Close whenever the route (language) actually changes, e.g. after a click.
  useEffect(() => setOpen(false), [lang])

  return (
    <div className="lang-switcher" ref={rootRef}>
      <button
        type="button"
        id={buttonId}
        className="lang-current"
        aria-haspopup="true"
        aria-expanded={open}
        aria-controls={menuId}
        aria-label={`${t.common.language}: ${current?.name}`}
        title={current?.name}
        onClick={() => setOpen((value) => !value)}
      >
        <Flag code={lang} />
        <svg className="lang-caret" viewBox="0 0 10 6" aria-hidden="true">
          <path d="M1 1l4 4 4-4" />
        </svg>
      </button>
      <ul id={menuId} role="menu" aria-labelledby={buttonId} className={`lang-menu${open ? ' is-open' : ''}`}>
        {languages.map((entry) => (
          <li key={entry.code} role="none">
            <Link
              role="menuitem"
              to={switchHref(entry.code)}
              lang={entry.code}
              className={`lang-option${lang === entry.code ? ' is-active' : ''}`}
              aria-current={lang === entry.code ? 'true' : undefined}
              tabIndex={open ? 0 : -1}
              onClick={() => setOpen(false)}
            >
              <Flag code={entry.code} />
              <span>{entry.name}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default LanguageSwitcher
